module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content__wrapper"
  }, [_c('h4', {
    staticClass: "stepper__content__title text-xs-left"
  }, [_vm._v(_vm._s(_vm.$t('IRELAND_AGREEMENT_1')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "stepper__content__title-description"
  }, [_vm._v(_vm._s(_vm.$t('IRELAND_AGREEMENT_2')))]), _vm._v(" "), _c('div', {
    staticClass: "content__wrapper flex-center"
  }, [_c('div', {
    staticClass: "flex-center flex-row"
  }, [_c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.irelandAgreement),
      expression: "irelandAgreement"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "name": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.irelandAgreement, true)
    },
    on: {
      "change": function($event) {
        _vm.irelandAgreement = true
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t('YES_I_WANT')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.irelandAgreement),
      expression: "irelandAgreement"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "name": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.irelandAgreement, false)
    },
    on: {
      "change": function($event) {
        _vm.irelandAgreement = false
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t('NO_I_DO_NOT_WANT')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.irelandAgreement),
      expression: "irelandAgreement"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "other",
      "name": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.irelandAgreement, "other")
    },
    on: {
      "change": function($event) {
        _vm.irelandAgreement = "other"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.$t('NO_I_DO_NOT_HAVE')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), (_vm.irelandAgreement === true) ? _c('form', [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^.+ .+$/
      }),
      expression: "{ required: true, regex: /^.+ .+$/ }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.trustedDoctorName),
      expression: "trustedDoctorName"
    }],
    staticClass: "text-input white-input-border",
    attrs: {
      "type": "text",
      "name": _vm.$t('NAME'),
      "placeholder": _vm.$t('NAME')
    },
    domProps: {
      "value": (_vm.trustedDoctorName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.trustedDoctorName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: _vm.emailRegex
      }),
      expression: "{ required: true, regex: emailRegex }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.trustedDoctorEmail),
      expression: "trustedDoctorEmail"
    }],
    staticClass: "text-input white-input-border",
    attrs: {
      "type": "email",
      "name": _vm.$t('EMAIL_ADDRESS'),
      "placeholder": _vm.$t('EMAIL_ADDRESS')
    },
    domProps: {
      "value": (_vm.trustedDoctorEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.trustedDoctorEmail = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.irelandAgreement !== '') ? _c('button', {
    staticClass: "w160 mr-3 app-btn app-btn--small app-btn-primary mt-3",
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('NEXT')) + "\n            ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5743e8ab","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/survey-ireland-agreement.vue
// module id = 1205
// module chunks = 0